/**
 * WHAT SHE TYPED, KEPT UNTIL SHE SAVES IT.
 *
 * Per task, in memory, for the session: leaving a half-typed reading to look
 * something up (the search, another patient in the round) and coming back
 * finds it where she left it. Nothing here is PHI in storage — it never leaves
 * the tab, and a reload starts clean.
 */
const store = new Map<string, Record<string, string>>();

export function readDraft<T extends Record<string, string>>(taskId: string | undefined): Partial<T> {
  const hit = taskId ? store.get(taskId) : undefined;
  return (hit ?? {}) as Partial<T>;
}

export function writeDraft(taskId: string | undefined, values: Record<string, string | undefined>) {
  if (!taskId) return;
  const clean = Object.fromEntries(Object.entries(values).filter(([, v]) => v)) as Record<string, string>;
  if (Object.keys(clean).length) store.set(taskId, clean);
  else store.delete(taskId);
}

export function clearDraft(taskId: string | undefined) {
  if (taskId) store.delete(taskId);
}

export function hasDraft(taskId: string | undefined): boolean {
  return Boolean(taskId && store.has(taskId));
}
